import Home from './pages/home/Index';
import Order from "./pages/order/Order";
import Pay from "./pages/pay/Pay";
import Space from "./pages/space/index";
import My from "./pages/my/My";
import Area from "./pages/area/Area";
import Login from "./pages/login/Login";
import MyCharge from "./pages/myCharge/Index";
import MyOrder from "./pages/myOrder/Index";
import SpaceList from "./pages/spaceList/Index";
import SpaceSearchList from "./pages/spaceSearchList/Index";
import SpaceInfo from './pages/spaceInfo/Index';
import Oauth from './pages/user-login/oauth';
import Bind from './pages/user-login/bind';
import PayOrder from './pages/payFor/index';
import PaySuccess from './pages/paySuccess/Index'
import PayFail from './pages/payFail/Index'
import SpaceDetail from './pages/spaceDetail/Index'

import Recharge from './pages/recharge/index';
import Forget from './pages/forget/index';
import PhoneBind from './pages/phoneBind/index';
import MyCard from './pages/myCard/index';
import Modify from './pages/modify/index';
import MyConsume from './pages/myConsume/Index';
import OrderDetail from './pages/orderDetail/index';

export default [
    {
        path: "/bind",
        component: Bind,
        key: 'bind'
    }
    ,
    {
        path: "/oauth",
        component: Oauth,
        key: 'oauth'
    }
    ,
    {
        path: "/home",
        component: Home,
        exact: true,
        key: 'home'
    },
    {
        path: "/",
        component: Login,
        exact: true,
        key: 'index'
    },
    {
        path: "/my",
        component: My,
        exact: true,
        key: 'my'
    },
    {
        path: "/pay",
        component: Pay,
        exact: true,
        key: 'pay'
    },
    {
        path: "/order",
        component: Order,
        exact: true,
        key: 'order'
    },
    {
        path: "/space/:id",
        component: Space,
        exact: true,
        key: 'space'
    },
    {
        path: "/spaceSearchList",
        component: SpaceSearchList,
        exact: true,
        key: 'spaceSearchList'
    },
    {
        path: "/area",
        component: Area,
        exact: true,
        key: 'area'
    },
    {
        path: "/login",
        component: Login,
        exact: true,
        key: 'login'
    },
    {
        path: "/myCharge",
        component: MyCharge,
        exact: true,
        key: 'myCharge'
    },
    {
        path: "/myOrder",
        component: MyOrder,
        exact: true,
        key: 'myOrder'
    },
    {
        path: "/spaceList",
        component: SpaceList,
        exact: true,
        key: 'spaceList'
    },
    {
        path: "/spaceInfo",
        component: SpaceInfo,
        exact: true,
        key: 'spaceInfo'
    },
    {
        path: "/payFor",
        component: PayOrder,
        exact: true,
        key: 'payOrder'
    },
    {
        path: "/paySuccess",
        component: PaySuccess,
        exact: true,
        key: 'paySuccess'
    },
    {
        path: "/payFail",
        component: PayFail,
        exact: true,
        key: 'payFail'
    },
    {
        path: "/spaceDetail",
        component: SpaceDetail,
        exact: true,
        key: 'spaceDetail'
    },
    {
        path: "/recharge",
        component: Recharge,
        exact: true,
        key: 'recharge'
    },
    {
        path: "/forget",
        component: Forget,
        exact: true,
        key: 'forget'
    },
    {
        path: "/phoneBind",
        component: PhoneBind,
        exact: true,
        key: 'phoneBind'
    },
    {
        path: "/myCard",
        component: MyCard,
        exact: true,
        key: 'myCard'
    },
    {
        path: "/modify",
        component: Modify,
        exact: true,
        key: 'modify'
    },
    {
        path: "/consume",
        component: MyConsume,
        exact: true,
        key: 'consume'
    },
    {
        path: "/orderDetail",
        component: OrderDetail,
        exact: true,
        key: 'orderDetail'
    }

];



